import React, { useEffect, useRef, useState } from 'react';

export function ConnectionLoader({ title = "יוצרים חיבור קטן…", detail, compact = false }) {
  return <div className={`connection-loader ${compact ? 'is-compact' : ''}`} role="status">
    <span className="connection-orbit" aria-hidden="true"><i /><i /><b>✦</b></span>
    <span className="connection-loader-copy"><strong>{title}</strong>{detail && <span>{detail}</span>}</span>
  </div>;
}

const titles = {
  1: ["טוב לראות אתכם שוב.", "השיחה הבאה שלכם מתחילה כאן."],
  2: ["ההתרגשות כבר כאן.", "מחפשים מישהו להכיר."],
  3: ["הנה אתם.", "חיבור חדש מחכה לכם."],
  4: ["מתחילים בקול.", "תנו לאישיות שלכם לדבר."],
  5: ["קצת מסתורין.", "הגיע הזמן להכיר קצת אחרת."],
  6: ["היי, נעים להכיר.", "רגע ששניכם בחרתם בו."],
  7: ["ניצוץ ששווה לשמור.", "החיבור שלכם נשמר."],
  8: ["הופכים את זה לדייט.", "ממשיכים לדבר ובוחרים יחד מקום לדייט ראשון."],
};

// A separate decorative layer never remounts the video elements or delays a stage.
export function StageTransition({ stage }) {
  const previous = useRef(stage);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (previous.current === stage) return;
    previous.current = stage;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) { setVisible(false); return; }
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 650);
    return () => clearTimeout(timer);
  }, [stage]);
  if (!visible || !titles[stage]) return null;
  return <div key={stage} className="connection-transition" aria-hidden="true">
    <span className="transition-spark">✦</span><strong>{titles[stage][0]}</strong><span>{titles[stage][1]}</span>
  </div>;
}
